import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { api } from "../api.js";
import { Button, Card, Field, Form, Input, Page, COLORS } from "../ui.js";

export default function Login() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "sent" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setStatus("loading");
    setErrorMsg("");
    try {
      await api.post("/auth/magic-link/request", { email, as: "formateur" });
      setStatus("sent");
    } catch (err) {
      setStatus("error");
      setErrorMsg(String(err));
    }
  }

  return (
    <div style={{ maxWidth: 420, margin: "10vh auto", padding: "0 20px" }}>
      <Page title="Connexion Formateur">
        <Card>
          {status === "sent" ? (
            <div>
              <p>
                Si un compte Formateur existe pour <strong>{email}</strong>, un lien de connexion vient
                d'être envoyé.
              </p>
              <p style={{ color: COLORS.muted, fontSize: 14 }}>
                En mode dev, le lien est imprimé dans la console du serveur API.
              </p>
              <Button variant="ghost" onClick={() => setStatus("idle")}>
                Renvoyer
              </Button>
            </div>
          ) : (
            <Form onSubmit={onSubmit}>
              <Field label="Email">
                <Input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="formateur@exemple.fr"
                  autoFocus
                />
              </Field>
              {errorMsg && <p style={{ color: COLORS.danger, fontSize: 13 }}>{errorMsg}</p>}
              <Button type="submit" disabled={status === "loading"}>
                {status === "loading" ? "Envoi…" : "Recevoir mon lien"}
              </Button>
            </Form>
          )}
        </Card>
        <p style={{ textAlign: "center", color: COLORS.muted }}>
          Pas encore d'Espace ? <Link to="/signup">Créez le vôtre</Link>
        </p>
      </Page>
    </div>
  );
}
